import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { HelpBar } from "./salesShared";
import { Layers, Plus, Trash2, Save } from "lucide-react";

const PRESETS = ["Blanco", "Mr John", "Clazing"];

export default function FoliesTab({ folies, reload }) {
  const [list, setList] = useState([]);
  const [nn, setNn] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const base = folies && folies.length ? folies : PRESETS;
    setList([...base]);
  }, [folies]);

  const latest = useRef([]);
  useEffect(() => { latest.current = list; }, [list]);
  const timer = useRef(null);
  const persist = async ({ silent } = {}) => {
    if (!silent) setSaving(true);
    try { await api.put("/sales/folies", { folies: latest.current }); if (!silent) toast.success("Folies bijgewerkt"); reload && reload(); }
    catch (e) { toast.error(formatApiError(e)); } finally { if (!silent) setSaving(false); }
  };
  const schedule = () => { clearTimeout(timer.current); timer.current = setTimeout(() => persist({ silent: true }), 700); };

  const add = () => {
    const v = nn.trim();
    if (!v) return toast.error("Vul een folienaam in.");
    if (list.some((x) => x.toLowerCase() === v.toLowerCase())) return toast.error("Deze folie bestaat al.");
    setList((l) => [...l, v]); setNn(""); schedule();
  };
  const remove = (i) => { setList((l) => l.filter((_, idx) => idx !== i)); schedule(); };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2"><Layers className="h-5 w-5 text-blue-700" /> Folies / verpakkingssoorten</h2>
        <Button data-testid="folie-save" onClick={() => persist()} disabled={saving} className="bg-[#1C64B0] hover:bg-[#154E8A]"><Save className="h-4 w-4 mr-1" /> {saving ? "Opslaan..." : "Opslaan"}</Button>
      </div>
      <HelpBar>Beheer hier de foliesoorten die het salesteam bij een offerte kan kiezen (bijv. <b>Blanco</b>, <b>Mr John</b>, <b>Clazing</b>). Voeg <b>eigen private-label folies</b> toe voor specifieke klanten. Wijzigingen worden <b>automatisch opgeslagen</b>.</HelpBar>

      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="text-sm font-bold text-slate-700 mb-2">Folie toevoegen</div>
        <div className="flex flex-wrap items-end gap-2 mb-4">
          <div><label className="block text-xs font-semibold text-slate-600 mb-1">Folienaam</label><Input data-testid="folie-new-naam" value={nn} onChange={(e) => setNn(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") add(); }} className="w-64" placeholder="bijv. Private label AH" /></div>
          <Button variant="outline" data-testid="folie-add" onClick={add}><Plus className="h-4 w-4 mr-1" /> Toevoegen</Button>
        </div>
        <div className="flex flex-wrap gap-2">
          {list.length === 0 && <span className="text-sm text-slate-400">Nog geen folies.</span>}
          {list.map((f, i) => (
            <span key={i} data-testid="folie-chip" className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-sm text-blue-800">
              {f}
              <button data-testid="folie-del" onClick={() => remove(i)} className="text-blue-500 hover:text-rose-600"><Trash2 className="h-3.5 w-3.5" /></button>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
